export default __webpack_public_path__ + "static/media/logo.e30fa70d.png";